import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const couponApi = createApi({
  reducerPath: 'couponApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api' }),
  tagTypes: ['Coupons'],
  endpoints: builder => ({
    getCoupons: builder.query<any, void>({
      query: () => ({
        url: '/users/coupons',
        method: 'GET',
        params: {
          order: 'highQuantity',
        },
      }),
      keepUnusedDataFor: 60 * 60,
    }),
  }),
});

export const { useGetCouponsQuery } = couponApi;
